import { Plus, Trash2 } from "lucide-react";
import { COLOR_NAMES, COLORS } from "@/lib/colors";
import { inputCls } from "./ui";

const Dot = ({ name }) => <span className="inline-block w-4 h-4 rounded-full border border-zinc-300 flex-shrink-0" style={{ background: COLORS[name] }} />;

export default function ColorStockEditor({ colors, onChange }) {
  const used = colors.map((c) => c.name);
  const unused = COLOR_NAMES.filter((n) => !used.includes(n));

  const addColor = (name) => onChange([...colors, { name: name || unused[0], stock: 0 }]);
  const setRow = (i, patch) => onChange(colors.map((c, j) => (j === i ? { ...c, ...patch } : c)));
  const removeRow = (i) => onChange(colors.filter((_, j) => j !== i));

  return (
    <div data-testid="color-stock-editor">
      {colors.length > 0 && (
        <div className="rounded-lg border border-zinc-200 divide-y divide-zinc-200 mb-4">
          <div className="hidden sm:grid grid-cols-[1fr_140px_40px] gap-3 px-3 py-2 text-xs font-medium text-zinc-500 bg-zinc-50 rounded-t-lg">
            <span>Color</span><span>In stock</span><span />
          </div>
          {colors.map((c, i) => (
            <div key={i} className="grid grid-cols-[1fr_110px_36px] sm:grid-cols-[1fr_140px_40px] gap-3 px-3 py-2.5 items-center" data-testid={`color-row-${i}`}>
              <div className="flex items-center gap-2.5">
                <Dot name={c.name} />
                <select value={c.name} onChange={(e) => setRow(i, { name: e.target.value })} className={inputCls} data-testid={`color-row-select-${i}`}>
                  {[c.name, ...unused].map((n) => <option key={n} value={n}>{n}</option>)}
                </select>
              </div>
              <input type="number" min={0} value={c.stock} onChange={(e) => setRow(i, { stock: Math.max(0, parseInt(e.target.value || "0", 10)) })}
                className={inputCls} data-testid={`color-row-stock-${i}`} aria-label={`${c.name} stock`} />
              <button type="button" onClick={() => removeRow(i)} className="w-9 h-9 rounded-lg flex items-center justify-center text-zinc-400 hover:text-red-600 hover:bg-red-50" data-testid={`color-row-remove-${i}`} aria-label="Remove color">
                <Trash2 size={16} />
              </button>
            </div>
          ))}
        </div>
      )}
      {unused.length > 0 && (
        <>
          <button type="button" onClick={() => addColor()} data-testid="add-color-button"
            className="inline-flex items-center gap-2 h-9 px-4 rounded-lg border border-zinc-300 bg-white text-sm font-medium hover:bg-zinc-50 shadow-sm">
            <Plus size={15} /> Add color
          </button>
          <div className="mt-4">
            <p className="text-xs text-zinc-500 mb-2">Or tap to add quickly:</p>
            <div className="flex flex-wrap gap-1.5">
              {unused.map((n) => (
                <button key={n} type="button" onClick={() => addColor(n)} data-testid={`quick-color-${n.toLowerCase()}`}
                  className="inline-flex items-center gap-1.5 h-7 pl-1.5 pr-2.5 rounded-full border border-zinc-200 bg-white text-xs text-zinc-700 hover:border-zinc-400">
                  <Dot name={n} /> {n}
                </button>
              ))}
            </div>
          </div>
        </>
      )}
    </div>
  );
}
